import {MemberPageState} from '../types/state'

export const isDemoMode = (state: MemberPageState) => state.view.demo

export const isNoEventsMode = (state: MemberPageState) => state.view.noEvents
